<template>
  <div class="inner">
    <div class="page_con">
      <div class="m_table detail">
        <ul class="m_table_ul">
          <li class="m_table_li">
            <div class="col">
              <div class="m_table_ttl">
                <span class="lock" :class="{'on' : form.inquiry.isSecret === 2}"></span><!--'on 추가'-->
                <span>{{ form.inquiry.title }}</span>
              </div>
              <div class="date"><span>{{ form.user.userId.replace( (form.user.userId).substring(form.user.userId.length -2, form.user.userId.length), '**' ) }}</span></div>
              <div class="date"><span>{{ $moment(form.inquiry.regDate).format('YYYY.MM.DD') }}</span></div>
            </div>
          </li>
          <li class="m_table_li">
            <div class="col">
              <div class="editor">
                <div  v-html="form.inquiry.contents" ></div>
              </div>
            </div>
          </li>
          <li class="m_table_li" v-if="!$Util.isEmpty(form.inquiry.answer)">
            <div class="col">
              <div class="m_table_con">
                <span>{{ form.inquiry.answer }}</span>
              </div>
              <div class="dl">
                <span class="dd">{{ form.admin.adminId.replace( (form.admin.adminId).substring(form.admin.adminId.length -2, form.admin.adminId.length), '**' ) }}</span>
                <span class="dt">｜ {{ form.inquiry.answerDate ? $moment(form.inquiry.answerDate).format('YYYY.MM.DD HH:mm') : '' }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <top-button />
  </div>
</template>

<script>
import TopButton from '@/components/pages/top/button'
export default {
  name: 'info-report-view',
  components: {TopButton},
  data() {
    return {
      form: {},
      params: {
        page: 1,
        limit: 10,
        inquiryNo: -1,
        reviewContent: ''
      }
    }
  },
  async created() {
    this.params.inquiryNo = this.$route.query.inquiryNo
    const res = await this.$InquirySvc.fetchData(this.params)
    this.form = res.entity
  }
}
</script>

<style scoped>

</style>
